<template>
  <div @click.prevent="redirectToHome" class="logo logo-container">
    <md-tooltip v-if="tooltip" :class="{ 'hide-text': !shrinkSideBar }" md-direction="right">{{ version }}</md-tooltip>
    <div class="simple-text logo-mini" :class="{ 'logo-with-version': version !== '' }">
      <div class="logo-img">
        <saman-logo class="logo" />
      </div>
    </div>

    <div class="simple-text logo-normal" :class="shrinkSideBar ? 'hide-text' : ''">
      {{ title }}
      <div @click.stop="showDetailsDialog = true" class="md-caption text-gray">{{ version }}</div>
    </div>
    <md-dialog
      :md-active.sync="showDetailsDialog"
      @md-clicked-outside="showDetailsDialog = false"
      @md-closed="showDetailsDialog = false"
    >
      <md-dialog-title>Saman Dashboard</md-dialog-title>
      <div class="md-dialog-content md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <div
          class="md-layout-item md-size-100 md-body-2"
          v-html="versionDetailsMessage"
          style="line-break: loose; text-align: justify"
        ></div>
        <div class="md-layout-item md-size-100 text-right">
          <md-button @click="showDetailsDialog = false">Close</md-button>
        </div>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import { onMounted, ref, watch } from "@vue/composition-api";
import apiManager from "../api-manager";
import SAMAN_CONFIG from "../global-config";
import samanLogo from "../assets/img/saman-logo.vue";

export default {
  name: "CoreVersion",
  components: {
    samanLogo,
  },
  props: {
    isSmall: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "SAMAN",
    },
    tooltip: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    const version = ref("");
    const getVersion = async () => {
      const response = await apiManager.getVersion();
      version.value = response.parsedData.version;
    };
    const shrinkSideBar = ref(false);
    watch(
      () => props.isSmall,
      (newValue, oldValue) => {
        shrinkSideBar.value = newValue;
      }
    );

    onMounted(() => {
      getVersion();
      shrinkSideBar.value = props.isSmall;
    });
    const showDetailsDialog = ref(false);
    const redirectToHome = () => {
      // todo change this in migration to vue 3
      const router = context.root.$router;
      router.push("/");
    };
    return {
      version,
      showDetailsDialog,
      versionDetailsMessage: SAMAN_CONFIG.versionDetails,
      shrinkSideBar,
      redirectToHome,
    };
  },
};
</script>

<style>
.hide-text {
  display: none !important;
}
.shrunk-side-bar .logo:after {
  display: none;
}
.logo-with-version {
  top: 5px !important;
}
.logo-container {
  height: 90px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
</style>
